<template>
    <v-card @click="$emit('click')" hover class="kim-card" >
        <v-card-title class="pb-1 pl-0">
            <v-list-tile avatar class="text-truncate">

                <v-list-tile-avatar>
                    <v-img :src="client && client.avatar || getFakeAvatar(client.gender)"/>
                </v-list-tile-avatar>

                <v-list-tile-content>

                    <v-list-tile-title>
                        {{client.first_name}} {{client.last_name}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                        {{clientRut}}
                    </v-list-tile-sub-title>

                </v-list-tile-content>

            </v-list-tile>
        </v-card-title>
        <v-card-text class="pt-0 px-4 text-xs-left">
            <div class="caption py-1 text-truncate">
                <v-icon size="13" color="primary" >fa-envelope</v-icon> {{client.email || 'n/d'}}
            </div>
            <div class="caption text-truncate">
                <v-icon size="14" color="primary" >fa-phone-square</v-icon> {{client.phone1 ? `+56${client.phone1}` : 'n/d'}}
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import {getFakeAvatar} from "@/utils/Common";

export default {
    name: "ClientCard",
    props:{
        client:{
            type: Object,
            required: true
        }
    },
    computed: {
        clientRut(vm = this) {
            if (!vm.client) return 'n/d'
            let rut = vm.client.dni
            return vm.client.is_foreign ? rut : vm.$options.filters.rut(rut)
        }
    },
    methods:{
        getFakeAvatar
    },
}
</script>

<style scoped>

</style>